import { useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";

import { useThunkDispatch } from "@/redux/dispatcher";
import * as AddressBookModule from "@/redux/modules/api/data/addressbook/addressbook.module";
import * as AddressBookSelectors from "@/redux/modules/api/data/addressbook/addressbook.selectors";
import { getAllowedDeliveryAddresses } from "@/utils/address/address";

export const useAddresses = () => {
    const dispatch = useThunkDispatch();

    const addresses = useSelector(
        AddressBookSelectors.getAddresses,
        shallowEqual
    );
    const loading = useSelector(AddressBookSelectors.isLoading);
    const error = useSelector(AddressBookSelectors.getErrors);

    const deliveryAddresses = getAllowedDeliveryAddresses(addresses);

    useEffect(() => {
        if (addresses.length || loading || (error || []).length > 0) return;

        dispatch(AddressBookModule.load());
    }, [loading, error, addresses.length, dispatch]);

    const hasAddresses = addresses.length > 0;

    return {
        addresses: addresses,
        deliveryAddresses: deliveryAddresses,
        hasAddresses: hasAddresses,
        addressesLoading: loading
    };
};
